import { render, staticRenderFns } from "./PictureUpload.vue?vue&type=template&id=68598009&scoped=true&"
import script from "./PictureUpload.vue?vue&type=script&lang=js&"
export * from "./PictureUpload.vue?vue&type=script&lang=js&"
import style0 from "./PictureUpload.vue?vue&type=style&index=0&id=68598009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68598009",
  null
  
)

export default component.exports